import React from 'react';
import TeamMember from './TeamMember';
import Marshall from '../img/Marshall.jpg';
import Val from '../img/Val.jpeg';
import Andrew from '../img/Andrew.png';
import Frances from '../img/Frances.jpg';

const Team = () => (
  <div id="team-list">
    <TeamMember
      name="Andrew"
      bio="Andrew is software engineer born and raised in Brooklyn, New York. Previously, he was a Transfer Pricing Tax Consultant at Ernst & Young providing tax advice to US headquartered banks and private equity clients. He’s attracted to technical challenges and enjoys immersing himself in learning about areas of interest such as software engineering, entrepreneurship, marketing, fitness, and horology."
      imgUrl={Andrew}
      github="https://github.com/andventuree"
      linkedIn="https://www.linkedin.com/in/andreww-wong/"
    />
    <TeamMember
      name="Val"
      bio="Val is a Software Engineer hailing from the Northeast. After graduating from University of Michigan with a degree in business, she spent time in Chicago and Detroit working as a Financial Analyst and Digital Strategy Associate. She’s now back in the Big Apple to pursue a career in development post her education at the Fullstack Academy of Code. In her free time, you can find her traveling, trying new brunch places, or watching Game of Thrones."
      imgUrl={Val}
      github="https://github.com/valpil"
      linkedIn="https://www.linkedin.com/in/valerie-pilossof/"
    />
    <TeamMember
      name="Frances"
      bio="Frances is a New York-based creative technologist and fullstack web developer, using cross-disciplinary approaches to craft engaging and interactive experiences across digital and physical spaces. She holds a Master of Music in Music Technology from NYU and a BA Multimedia Design from Northumbria University. Her artwork has been exhibited at various galleries and festivals around the world."
      imgUrl={Frances}
      github="https://github.com/francesyw"
      linkedIn="https://www.linkedin.com/in/francesyuanwang/"
    />
    <TeamMember
      name="Marshall"
      bio="Marshall is a fullstack JavaScript engineer living in New York
              City. He has prior work experience as a consultant for PwC and
              Grant Thornton. Marshall is graduate of Fullstack Academy of Code
              and the College of William and Mary. His interests include data
              modeling and analysis, capital markets, and anything related to
              film or baseball."
      imgUrl={Marshall}
      github="https://github.com/dmzobel"
      linkedIn="https://www.linkedin.com/in/marshallzobel/"
    />
  </div>
);

export default Team;



// WEBPACK FOOTER //
// ./src/components/Team.js